var path = 'group/entity-group-card.tpl.html';
var html = " <div flex layout=column> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/group/entity-group-card.tpl.html
// module id = 1520
// module chunks = 1